<div class="app-nav__division">
    <span class="app-nav__division-label">
        {{ getDisplay(control.value) }}
    </span>
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-chevron-down"></use></svg>

    <mat-form-field appearance="fill" class="filter-bar__dropdown-overlay" [attr.aria-label]="label">
        <div>
            <mat-select
                [formControl]="control"
                [compareWith]="compareByValueKey"
                (selectionChange)="onSelectionChange($event.value)"
                panelClass="filter-select-panel"
                #matSelect
            >
                <mat-select-trigger class="client-picker__trigger">&nbsp;</mat-select-trigger>

                <div class="client-picker__search-wrap">
                    <div class="filter-bar__search">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-search"></use></svg>
                        <input #searchInput [formControl]="searchControl" type="search" autocomplete="off" placeholder="Search clients..." />
                        @if (searchControl.value) {
                            <button
                                type="button"
                                class="filter-bar__search-clear"
                                title="Clear"
                                (click)="$event.stopPropagation(); onClearSearch()"
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><use href="#icon-close"></use></svg>
                            </button>
                        }
                    </div>
                </div>

                @if (keywordLoading) {
                    <div class="client-picker__spinner-wrap">
                        <svg class="loader-spinner loader-spinner--sm" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><use href="#icon-spinner"></use></svg>
                    </div>
                }
                <ng-content>
                    @if (options.length === 0 && !keywordLoading && !loading) {
                        <mat-option disabled>No results match your search</mat-option>
                    }

                    @for (option of options; track option) {
                        <mat-option [value]="option">
                            <span class="menu__checkbox" [class.menu__checkbox--checked]="compareByValueKey(option, control.value)">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5"><use href="#icon-check"></use></svg>
                            </span>
                            {{ getDisplay(option) }}
                        </mat-option>
                    }

                    @if (loading) {
                        <div class="client-picker__spinner-wrap">
                            <svg
                                class="loader-spinner loader-spinner--sm"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            ><use href="#icon-spinner"></use></svg>
                        </div>
                    }
                </ng-content>
            </mat-select>
        </div>
    </mat-form-field>
</div>
